import { useQuery } from '@tanstack/react-query';

import { BlockMappingValidationRouteFile } from '../interfaces';
import { BlockMappingValidationService } from '../services';
import { useFleet } from '../hooks/useFleet';

const QUERY_KEY = 'block-mapping-validation-route-files';

export const useBlockMappingValidationRouteFilesQuery = () => {
  const fleet = useFleet();

  return useQuery<BlockMappingValidationRouteFile[]>({
    queryKey: [QUERY_KEY, fleet?.uuid],
    queryFn: () => BlockMappingValidationService.listRouteFiles(),
    enabled: !!fleet?.uuid,
  });
};
